import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Footer, SectionCard } from "@/components/common/Page";
import { Button } from "@/components/ui/button";
import { Link2, Shield, LogOut } from "lucide-react";

export default function Settings() {
    const { user, logout, isAdmin } = useAuth();
    const navigate = useNavigate();
    return (
        <div data-testid="player-settings">
            <PageHeader title="Settings" subtitle="Manage your Outpost Network profile." />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                <SectionCard title="Profile">
                    <div className="flex items-center gap-4">
                        <img src={user?.avatar || `https://api.dicebear.com/7.x/bottts/svg?seed=${user?.username}`}
                            className="h-16 w-16 rounded-lg border border-border bg-background" alt="avatar" />
                        <div>
                            <div className="font-heading text-xl font-bold text-foreground">{user?.username}</div>
                            <div className="text-sm text-muted-foreground">{user?.email}</div>
                            <div className="label-mono text-hazard mt-1">{(user?.role || "").replace(/_/g, " ")}</div>
                        </div>
                    </div>
                    <div className="mt-4 flex flex-wrap gap-2">
                        {(user?.outpost_roles || []).map((r) => (
                            <span key={r} className="rounded-sm border border-border bg-background/50 px-2 py-0.5 label-mono text-muted-foreground">{r}</span>
                        ))}
                    </div>
                </SectionCard>

                <SectionCard title="Quick Actions">
                    <div className="space-y-2">
                        <Button data-testid="settings-connections" variant="outline" className="w-full justify-start border-discord/40 text-discord hover:bg-discord/10"
                            onClick={() => navigate("/player/connections")}>
                            <Link2 size={15} className="mr-2" /> Manage Discord Connection
                        </Button>
                        {isAdmin && (
                            <Button data-testid="settings-admin" variant="outline" className="w-full justify-start border-burnt/40 text-burnt hover:bg-burnt/10"
                                onClick={() => navigate("/admin/overview")}>
                                <Shield size={15} className="mr-2" /> Open Admin Control Center
                            </Button>
                        )}
                        <Button data-testid="settings-logout" variant="outline" className="w-full justify-start border-danger/40 text-danger hover:bg-danger/10"
                            onClick={logout}>
                            <LogOut size={15} className="mr-2" /> Log Out
                        </Button>
                    </div>
                </SectionCard>
            </div>
            <Footer />
        </div>
    );
}
